var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStandarIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_396_1838)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.37185 0.23816C1.53748 0.416095 0.740616 0.996728 0.328121 1.74593L0.0468744 2.25164L0.0187498 23.8568L0 45.4619L0.196873 45.9863C0.45937 46.6793 1.12499 47.3536 1.8281 47.6158L2.3531 47.8125H23.9997H45.6463L46.1713 47.6158C46.8651 47.3536 47.5401 46.6793 47.8026 45.9863C47.9994 45.4712 47.9994 45.387 47.9994 34.6172C47.9994 22.4333 48.0463 23.2949 47.2869 22.4426C47.0526 22.1804 46.6495 21.8714 46.3776 21.7403C46.012 21.5717 43.6307 21.066 36.9652 19.7455L28.0403 17.9849L28.0122 11.8508L27.984 5.7167L27.7215 5.18289C27.4309 4.5929 26.9153 4.09655 26.2872 3.79687C25.9684 3.6564 23.1935 3.19751 14.7842 1.92386C8.69052 1.00609 3.49683 0.228795 3.23434 0.2007C2.98121 0.172605 2.58747 0.191335 2.37185 0.23816ZM14.1561 3.93735C20.1654 4.84575 25.1997 5.63241 25.3497 5.6886C25.4903 5.74479 25.6966 5.92273 25.7903 6.08194C25.9591 6.36289 25.9684 6.96225 25.9684 26.0575V45.7522H23.0154H20.0716L20.0435 40.9011L20.0154 36.0594L19.7529 35.5349C19.4529 34.9169 18.8248 34.2988 18.206 34.0178C17.7748 33.8211 17.6623 33.8118 14.0061 33.8118H10.2468L9.59989 34.1396C9.14052 34.3737 8.85927 34.5984 8.60615 34.9356C7.96866 35.7691 7.96866 35.7784 7.96866 41.0416V45.7522H5.39056C2.57809 45.7522 2.3906 45.7241 2.17497 45.2371C2.0156 44.9 2.0156 3.13195 2.1656 2.83227C2.32497 2.51386 2.64372 2.29847 2.95309 2.29847C3.10309 2.29847 8.1374 3.0383 14.1561 3.93735ZM36.8902 21.8714C45.412 23.5477 45.4213 23.5477 45.6838 23.838L45.937 24.119V34.561C45.937 42.4463 45.9088 45.0498 45.8245 45.2371C45.5807 45.7709 45.937 45.7522 36.6089 45.7522H28.0309V32.9315C28.0309 20.7663 28.0403 20.1107 28.1997 20.1482C28.284 20.1669 32.2027 20.9442 36.8902 21.8714ZM17.5029 36.0688C17.9717 36.4246 17.9904 36.5557 17.9904 41.3225L17.9998 45.7522H14.0155H10.0311V41.2102C10.0311 37.4735 10.0593 36.6119 10.1624 36.4059C10.2843 36.1718 10.4999 36.0126 10.8749 35.8815C10.9499 35.8534 12.4124 35.844 14.128 35.8534C17.1185 35.8721 17.2498 35.8815 17.5029 36.0688Z",
    fill: "url(#paint0_linear_396_1838)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.12767 10.407C7.76076 10.7758 7.6779 11.2253 7.91462 11.721C8.12767 12.182 8.54193 12.3203 9.7492 12.3203C10.7434 12.3203 10.8736 12.2973 11.1458 12.0437C11.3115 11.8938 11.4773 11.6287 11.5128 11.4558C11.6074 11.0524 11.3234 10.3609 11.0038 10.1995C10.8618 10.1303 10.2463 10.0727 9.619 10.0727C8.51826 10.0727 8.45908 10.0842 8.12767 10.407Z",
    fill: "url(#paint1_linear_396_1838)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0257 10.4123C16.7808 10.6698 16.6875 10.8688 16.6875 11.1849C16.6875 12.0746 17.2006 12.4141 18.5418 12.4141C19.5098 12.4141 19.8713 12.297 20.1395 11.8756C20.4661 11.3839 20.3961 10.7869 19.9646 10.4006C19.6147 10.0962 19.5331 10.0728 18.4835 10.0728C17.4106 10.0728 17.3523 10.0845 17.0257 10.4123Z",
    fill: "url(#paint2_linear_396_1838)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.43112 17.8118C7.71498 18.1177 7.55982 19.0941 8.1208 19.6588C8.45499 19.9882 8.51467 20 9.56501 20C10.2931 20 10.7586 19.9412 10.9973 19.8235C11.785 19.4235 11.6776 18.1647 10.8302 17.8236C10.305 17.6118 8.92049 17.6 8.43112 17.8118Z",
    fill: "url(#paint3_linear_396_1838)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9117 18.1295C16.4685 18.5376 16.4925 19.2291 16.9596 19.6712C17.307 19.9887 17.343 20 18.5049 20C19.6309 20 19.7148 19.9887 20.0143 19.7052C20.4455 19.2858 20.4575 18.5262 20.0262 18.1295C19.7507 17.8687 19.6549 17.846 18.469 17.846C17.2831 17.846 17.1872 17.8687 16.9117 18.1295Z",
    fill: "url(#paint4_linear_396_1838)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.12329 25.7728C7.85202 26.043 7.78125 26.2192 7.78125 26.6068C7.78125 27.5231 8.42994 27.852 10.034 27.758C10.777 27.7228 10.9068 27.6758 11.1544 27.3939C11.3549 27.1589 11.4375 26.924 11.4375 26.5481C11.4375 26.1252 11.3785 25.996 11.0719 25.7376C10.7416 25.4557 10.6237 25.4322 9.58579 25.4322C8.5125 25.4322 8.45353 25.4439 8.12329 25.7728Z",
    fill: "url(#paint5_linear_396_1838)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9537 25.7804C16.4968 26.2486 16.4728 26.945 16.8936 27.4373C17.1822 27.7614 17.2062 27.7734 18.4687 27.7734C19.7313 27.7734 19.7553 27.7614 20.0439 27.4373C20.4647 26.945 20.4407 26.2486 19.9838 25.7804C19.6351 25.4442 19.587 25.4322 18.4687 25.4322C17.3505 25.4322 17.3024 25.4442 16.9537 25.7804Z",
    fill: "url(#paint6_linear_396_1838)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4349 27.9497C33.8631 28.2962 33.7881 29.1016 34.2756 29.5885L34.5193 29.832H36.9474C38.4381 29.832 39.4506 29.7946 39.5631 29.7384C39.8068 29.5979 40.0224 29.1577 40.0224 28.7644C40.0224 28.5303 39.9381 28.343 39.7506 28.1276L39.4787 27.8186L37.0974 27.7905C34.9037 27.7717 34.7068 27.7811 34.4349 27.9497Z",
    fill: "url(#paint7_linear_396_1838)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4349 33.9418C33.8631 34.2884 33.7881 35.0937 34.2756 35.5807L34.5193 35.8242H36.9474C38.4381 35.8242 39.4506 35.7868 39.5631 35.7306C39.8068 35.5901 40.0224 35.1499 40.0224 34.7566C40.0224 34.5225 39.9381 34.3352 39.7506 34.1198L39.4787 33.8107L37.0974 33.7826C34.9037 33.7639 34.7068 33.7733 34.4349 33.9418Z",
    fill: "url(#paint8_linear_396_1838)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4349 39.9379C33.8631 40.2844 33.7881 41.0898 34.2756 41.5768L34.5193 41.8203H36.9474C38.4381 41.8203 39.4506 41.7829 39.5631 41.7267C39.8068 41.5862 40.0224 41.146 40.0224 40.7527C40.0224 40.5186 39.9381 40.3313 39.7506 40.1159L39.4787 39.8068L37.0974 39.7787C34.9037 39.76 34.7068 39.7694 34.4349 39.9379Z",
    fill: "url(#paint9_linear_396_1838)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_396_1838",
    x1: 0.210907,
    y1: 23.9701,
    x2: 48,
    y2: 23.9701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C8FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.343347,
    stopColor: "#5C8EF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667816,
    stopColor: "#7E8DF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B8DF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_396_1838",
    x1: 7.79773,
    y1: 11.1951,
    x2: 11.5313,
    y2: 11.1951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C8FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.343347,
    stopColor: "#5C8EF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667816,
    stopColor: "#7E8DF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B8DF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_396_1838",
    x1: 16.7036,
    y1: 11.242,
    x2: 20.3438,
    y2: 11.242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C8FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.343347,
    stopColor: "#5C8EF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667816,
    stopColor: "#7E8DF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B8DF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_396_1838",
    x1: 7.79773,
    y1: 18.8279,
    x2: 11.5313,
    y2: 18.8279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C8FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.343347,
    stopColor: "#5C8EF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667816,
    stopColor: "#7E8DF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B8DF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_396_1838",
    x1: 16.6102,
    y1: 18.9217,
    x2: 20.3438,
    y2: 18.9217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C8FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.343347,
    stopColor: "#5C8EF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667816,
    stopColor: "#7E8DF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B8DF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_396_1838",
    x1: 7.79732,
    y1: 26.6013,
    x2: 11.4375,
    y2: 26.6013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C8FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.343347,
    stopColor: "#5C8EF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667816,
    stopColor: "#7E8DF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B8DF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_396_1838",
    x1: 16.6102,
    y1: 26.6013,
    x2: 20.3438,
    y2: 26.6013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C8FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.343347,
    stopColor: "#5C8EF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667816,
    stopColor: "#7E8DF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B8DF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_396_1838",
    x1: 33.9798,
    y1: 28.8065,
    x2: 40.0224,
    y2: 28.8065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C8FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.343347,
    stopColor: "#5C8EF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667816,
    stopColor: "#7E8DF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B8DF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_396_1838",
    x1: 33.9798,
    y1: 34.7987,
    x2: 40.0224,
    y2: 34.7987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C8FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.343347,
    stopColor: "#5C8EF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667816,
    stopColor: "#7E8DF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B8DF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_396_1838",
    x1: 33.9798,
    y1: 40.7948,
    x2: 40.0224,
    y2: 40.7948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C8FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.343347,
    stopColor: "#5C8EF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667816,
    stopColor: "#7E8DF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B8DF2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_396_1838"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandarIcon2);
export default __webpack_public_path__ + "static/media/standar-icon-2.81b66f4e947c001cb0d7f210034a72e1.svg";
export { ForwardRef as ReactComponent };